export default "__VITE_ASSET__CWXphJKj__"